import * as React from "react";
import ISPVsContainerProps from "./ISPVsContainer";
import Header from "@appComponents/Header/Header";
import SPVsList from "@market/components/SPVsList/SPVsList";
import Loader from "@appComponents/Loader/Loader";
import RiskNotice from "../RiskNotice/RiskNotice";
import { connect } from "react-redux";

import * as general from "@appStyles/general.module.scss";
import * as style from "./SPVsContainerStyle.module.scss";

export const SPVsContainer = (props: ISPVsContainerProps) => {
  return (
    <>
      <Header padding={"50 20"}>
        <h1 className={style.title}>Trade Private Equity</h1>
      </Header>
      <RiskNotice />
      <div className={[general.appContainer, style.sharesContainer].join(" ")}>
        {props.spvs ? (
          <SPVsList spvsList={props.spvs} />
        ) : (
          <div className={style.loaderContainer}>
            <Loader />
          </div>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (store: any) => ({
  spvs: store.secondaryMarketReducer.spvs,
});

export default connect(mapStateToProps)(SPVsContainer);
